/* Hide the top nav when scrolling DOWN (past the top region) for a cleaner
   view; slide it back the instant you scroll UP. */
(function () {
  var nav = document.querySelector('.nesw-topnav');
  if (!nav) return;
  var lastY = window.pageYOffset || document.documentElement.scrollTop || 0;
  var TOP_ZONE = 140; /* always show within this many px of the top */
  var DELTA = 6;      /* ignore tiny jitters */
  var ticking = false;
  function update() {
    ticking = false;
    /* This theme scrolls via <body> (body{overflow-y:scroll}), not the window,
       so read whichever element actually holds the scroll position. */
    var y = window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop || 0;
    /* Don't hide while a drawer/menu is open. */
    if (document.body.classList.contains('has-nesw-sidebar-open')) { nav.classList.remove('nesw-topnav--hidden'); lastY = y; return; }
    if (Math.abs(y - lastY) < DELTA) return;
    if (y > lastY && y > TOP_ZONE) {
      nav.classList.add('nesw-topnav--hidden');     /* scrolling down */
    } else {
      nav.classList.remove('nesw-topnav--hidden');  /* scrolling up */
    }
    lastY = y;
  }
  /* capture:true so we still hear the event when <body> (not window) is the
     scroller. */
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }, { capture: true, passive: true });
})();
